import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { de_StartFaceSearchCommand, se_StartFaceSearchCommand } from "../protocols/Aws_json1_1";
export { $Command };
export class StartFaceSearchCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("RekognitionService", "StartFaceSearch", {})
    .n("RekognitionClient", "StartFaceSearchCommand")
    .f(void 0, void 0)
    .ser(se_StartFaceSearchCommand)
    .de(de_StartFaceSearchCommand)
    .build() {
}
